import React, { useEffect, useState } from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import { CheckCircleTwoTone, CloseCircleTwoTone } from '@ant-design/icons';
import { Empty } from 'antd';
import moment from 'moment-timezone';
import { useSelector } from 'react-redux';

const AreaGredientChartY = ({ datal }) => {
  moment.tz.setDefault("Asia/Calcutta|Asia/Kolkata");
  const [data, setData] = useState([]);
  const [offset, setOffset] = useState(null);
  const [isOffsetSet, setIsOffsetSet] = useState(false);
  const { darkmode } = useSelector((state) => state.darkmode);
  const calculateOffset = () => {
    if (!data || data.length === 0) return 0.5; // Default to middle

    const dataMax = Math.max(...data.map((i) => i.pnl));
    const dataMin = Math.min(...data.map((i) => i.pnl));

    if (dataMax <= 0) return 0;
    if (dataMin >= 0) return 1;

    return dataMax / (dataMax - dataMin);
  };

  useEffect(() => {

    if (Array.isArray(datal)) {
      setData(datal);
    }
  }, [datal]);

  useEffect(() => {
    if (data.length > 0) {
      const offsetValue = calculateOffset();
      setOffset(offsetValue);
      setIsOffsetSet(true);
    } else {
      setIsOffsetSet(false);
    }
  }, [data]);

  const CustomTooltip = (point) => {
    if (point) {
      const { y, date } = point.point;
      return `
        <div style="padding: 10px; width: 150px; text-align: left;">
          <p style="font-size: 12px;">
            ${y >= 0 ? `<span style="color: #2ecc71;">&#10003; Profit</span>` : `<span style="color: #e74c3c;">&#10005; Loss</span>`}
          </p>
          <p style="font-size: 12px;">Time: ${moment(point.x).format('h:mm A')}</p> 
          <p style="font-size: 12px;">Net P&L: ₹ ${y}</p>
        </div>
      `;
    }
    return null;
};

  const options = {
    chart: {
      type: 'area', // Use 'area' for fill
      height: 150,
      backgroundColor: darkmode ? '#141414' : '#ffffff',
    },
    accessibility: {
      enabled: false
    },
    title: {
      text: '',
    },
    legend: {
      enabled: false, // Disable legend
    },
    xAxis: {
      type: 'datetime',
      labels: {
        style: {
          fontSize: '10px',  // Adjust this to make the font smaller
        },
        formatter: function () {
          return moment(this.value).format('h:mm A');
        },
      },
    },
    yAxis: {
      
      title: {
        text: 'Realised P&L (₹)',
      },
      labels: {
        style: {
          fontSize: '10px',  // Adjust this to make the font smaller
        },
        formatter: function () {
          return `₹ ${this.value}`;
        },
      },
    },
    tooltip: {
      useHTML: true,
      formatter: function () {
        return CustomTooltip(this);
      },
    },
    plotOptions: {
      area: {
        stacking: 'normal', // Ensure stacking for fills
        fillOpacity: 0.3, // Base fill opacity
        marker: {
          enabled: false,
        },
      },
    },
    series: [
      {
        name: 'Running P&L Area',
        data: data.map(item => [new Date(item.date).getTime(), item.pnl]),
        color: '#2980b9',
        fillColor: {
          linearGradient: {
            x1: 0,
            y1: 0,
            x2: 0,
            y2: 1,
          },
          stops: [
            [0, 'rgba(46, 204, 113, 1)'], // Start with lower opacity
            [offset || 0, 'rgba(46, 204, 113, 0.3)'], // Full opacity at offset
            [offset || 0, 'rgba(231, 76, 60, 0.3)'], // Transition to another color
            [1, 'rgba(231, 76, 60, 1)'], // End with lower opacity
          ],
        },
        type: 'area',
      }
    ],
  };

  return (
    <div style={{ height: 150, textAlign: "center", marginBottom: "20px" }}>
      {data.length > 0 && isOffsetSet ? (
        <HighchartsReact
          highcharts={Highcharts}
          options={options}
        />
      ) : (
        <Empty description="No data available" />
      )}
    </div>
  );
};

export default AreaGredientChartY;

